<template>
  <v-container fluid class="contract-detail" v-if="contract">
    <v-row class="flex-grow-0">
      <v-btn text x-small color="primary" exact :to="{ name: 'contract-list' }">
        &lt;&lt; {{ $t("app_drawer.contract") }}
      </v-btn>
    </v-row>

    <v-row class="contract-info-wrapper">
      <v-col cols="12">
        <div class="contract-info">
          <h3>[{{ contract.id }}] {{ contract.name }}</h3>
        </div>
      </v-col>
      <v-col cols="12">
        <span class="contract-finalised-div">
          {{
            contract.finalised_at
              ? $t("contract.finalised")
              : $t("contract.not_finalised")
          }}
          <v-icon color="#5BC23F" small v-if="contract.finalised_at"
            >mdi-check</v-icon
          >
        </span>
      </v-col>
    </v-row>

    <v-row class="breadcrumbs">
      <v-col>
        <v-btn-toggle>
          <v-btn color="primary">Info </v-btn>
          <v-btn
            outlined
            text
            :to="{
              name: 'contract-work-orders',
              params: { contractId: $route.params.contractId },
            }"
            >Work Order
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <!--SoR + Details-->
    <v-row
      :class="[
        'contract-detail-row',
        'mt-8',
        'rounded',
        { finalised: contract.sor },
      ]"
    >
      <v-col cols="12" class="d-flex">
        <span class="font-weight-bold mr-8">{{ $t("contract.sor") }}</span>
        <v-btn
          color="primary"
          small
          v-if="!contract.sor && canManageContract"
          @click="$refs.sorForm.validate() && finaliseContractSor()"
        >
          {{ $t("contract.finalise") }}
        </v-btn>
        <v-spacer></v-spacer>
        <span class="text--disabled" v-if="contract.sor">{{
          $t("contract.finalised")
        }}</span>
      </v-col>
      <v-col cols="12" class="pa-0">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" v-if="!contract.sor">
        <v-form ref="sorForm">
          <v-select
            outlined
            :items="sorOptions"
            v-model="selectedSorId"
            :label="$t('contract.sor')"
            :rules="requiredRules"
          ></v-select>
          <v-textarea
            outlined
            v-model="contract.details"
            :label="$t('contract.details')"
            hide-details
            auto-grow
            no-resize
          ></v-textarea>
        </v-form>
      </v-col>
      <v-col cols="12" v-if="contract.sor">
        <v-row class="flex-grow-0">
          <v-col cols="3">{{ $t("contract.sor") }}:</v-col>
          <v-col cols="9">{{ contract.sor.name }}</v-col>
        </v-row>
        <v-row class="flex-grow-0">
          <v-col cols="3">{{ $t("contract.details") }}:</v-col>
          <v-col cols="9">
            <v-textarea
              filled
              flat
              readonly
              v-model="contract.details"
              hide-details
              auto-grow
              no-resize
            ></v-textarea>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!--ASoR-->
    <v-row class="contract-disable-row mt-8 rounded" v-if="!contract.sor">
      <v-col>
        <span class="font-weight-bold mr-8">{{ $t("contract.a_sor") }}</span>
        {{ $t("contract.a_sor_not_available") }}
      </v-col>
    </v-row>
    <v-row
      :class="[
        'contract-detail-row',
        'mt-8',
        'rounded',
        { finalised: contract.a_sor && contract.a_sor.finalised_at },
      ]"
      v-if="contract.sor"
    >
      <v-col cols="12" class="d-flex">
        <span class="font-weight-bold">{{ $t("contract.a_sor") }}</span>
        <!--        <v-btn color="primary"-->
        <!--               small-->
        <!--               class="ml-4"-->
        <!--               v-if="!contract.a_sor || !contract.a_sor.finalised_at"-->
        <!--               @click="downloadASoRTemplate">-->
        <!--          Download Template-->
        <!--        </v-btn>-->
        <v-btn
          color="primary"
          small
          class="ml-4"
          v-if="canManageContract && (!contract || !contract.finalised_at)"
          @click="createASoR"
        >
          <v-icon>mdi-plus</v-icon>
          New
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          small
          class="ml-4"
          v-if="canManageContract && !contract.finalised_at"
          @click="finaliseASoR"
        >
          Finalise
        </v-btn>
        <!--        <v-btn color="primary"-->
        <!--               small-->
        <!--               class="ml-4"-->
        <!--               v-if="canManageContract && contract.finalised_at"-->
        <!--               @click="unfinaliseASoR">-->
        <!--          Un-Finalise-->
        <!--        </v-btn>-->
        <span
          class="text--disabled"
          v-if="contract.a_sor && contract.a_sor.finalised_at"
          >{{ $t("contract.finalised") }}</span
        >
      </v-col>
      <v-col cols="12" class="pa-0">
        <ContractASorList
          :contract-id="contract.id"
          :refresh-trigger.sync="aSorRefreshTrigger"
          :contract="contract"
        >
        </ContractASorList>
      </v-col>
    </v-row>

    <!--Contract ACTION Input-->
    <v-row
      class="contract-disable-row mt-8 rounded"
      v-if="!contract.finalised_at"
    >
      <v-col>
        <span class="font-weight-bold mr-8">{{
          $t("contract.action_input")
        }}</span>
        {{ $t("contract.action_input_not_available") }}
      </v-col>
    </v-row>
    <v-row
      :class="[
        'contract-detail-row',
        'mt-8',
        'rounded',
        { finalised: contract.action_input },
      ]"
      v-if="contract.action_input"
    >
      <v-col cols="12" class="d-flex">
        <span class="font-weight-bold">{{ $t("contract.action_input") }}</span>
        <v-btn
          color="primary"
          small
          class="ml-4"
          :disabled="!contract.action_input"
          @click="$downloadFile(contract.action_input.id)"
        >
          {{ $t("sor.download_action_input") }}
        </v-btn>
        <v-btn
          color="primary"
          small
          class="ml-4"
          :disabled="!contract.action_input"
          @click="$downloadFile(contract.action_input.id)"
        >
          {{ $t("sor.download_action_input_dbf") }}
        </v-btn>
        <v-spacer></v-spacer>
        <span class="text--disabled" v-if="contract.action_input">{{
          $t("contract.finalised")
        }}</span>
      </v-col>
      <v-col cols="12" class="pa-0">
        <v-data-table
          :items="contractActionItems"
          :headers="actionHeaders"
          hide-default-header
          hide-default-footer
        >
          <template #no-data>
            {{ $t("sor.action_input_being_generated") }}
          </template>
          <template #item.created_at="{ value }">
            {{ $parseDate(value) }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!--Contract Percentage-->
    <v-row
      class="contract-disable-row mt-8 rounded"
      v-if="!contract.finalised_sor"
    >
      <v-col>
        <span class="font-weight-bold mr-8">{{
          $t("contract.contract_percentage")
        }}</span>
        {{ $t("contract.contract_percentage_not_available") }}
      </v-col>
    </v-row>
    <v-row
      class="contract-detail-row mt-8 rounded"
      v-if="contract.finalised_sor"
    >
      <v-col cols="12" class="d-flex">
        <span class="font-weight-bold">{{
          $t("contract.contract_percentage")
        }}</span>
        <v-btn
          color="primary"
          small
          class="ml-4"
          v-if="canManageContract"
          @click="downloadContractPercentageTemplate"
        >
          Download Template
        </v-btn>
        <v-btn
          color="primary"
          small
          class="ml-4"
          v-if="canManageContract"
          @click="importContractPercentageTemplate"
        >
          Create
        </v-btn>
      </v-col>
      <v-col cols="12" class="pa-0">
        <ContractYearList
          :contract-id="$route.params.contractId"
          :refresh-trigger.sync="contractYearRefreshTrigger"
          :contract="contract"
        ></ContractYearList>
      </v-col>
    </v-row>

    <!--Contract Admin-->
    <v-row class="contract-detail-row mt-8 rounded-t">
      <v-col cols="12" class="d-flex">
        <span class="font-weight-bold">{{ $t("contract_admin.title") }}</span>
        <v-btn
          color="primary"
          small
          class="ml-4"
          v-if="canManageContract"
          @click="addContractAdmin"
        >
          {{ $t("contract_admin.add_title") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="flex-grow-0 rounded-b">
      <ContractAdminList
        :contract-id="$route.params.contractId"
        :refresh-trigger.sync="contractAdminRefreshTrigger"
      ></ContractAdminList>
    </v-row>

    <!--Contract User-->
    <v-row class="contract-detail-row mt-8 rounded-t">
      <v-col cols="12" class="d-flex">
        <span class="font-weight-bold">{{ $t("contract_user.title") }}</span>
        <v-btn
          color="primary"
          small
          class="ml-4"
          v-if="canManageContract"
          @click="addContractUser"
        >
          {{ $t("contract_user.add_title") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="flex-grow-0 rounded-b">
      <ContractUserList
        :contract-id="$route.params.contractId"
        :refresh-trigger.sync="contractUserRefreshTrigger"
      ></ContractUserList>
    </v-row>
  </v-container>
</template>

<script>
import { computed, onMounted, ref } from "@vue/composition-api";
import SorList from "@/components/sor/SorList";
import { ACTION_TYPES } from "@/store/types";
import SectionList from "@/components/section/SectionList";
import VolumeList from "@/components/volume/VolumeList";
import ContractASorPreviewModal from "@/components/contract/ContractASorPreviewModal";
import ContractYearList from "@/components/contract/ContractYearList";
import ImportContractPercentageDialog from "@/components/contract/ImportContractPercentageDialog";
import SelectAccountDialog from "@/components/SelectAccountDialog";
import ContractAdminList from "@/components/contract/ContractAdminList";
import { PERMISSIONS, SOR_TYPE } from "@/constants";
import ContractASorList from "@/components/contract/ContractASorList";
import CreateContractASoRDialog from "@/components/contract/CreateContractASoRDialog";
import _ from "lodash";
import ContractUserList from "@/components/contract/ContractUserList";

export default {
  name: "Contract",
  components: {
    ContractUserList,
    ContractASorList,
    ContractAdminList,
    ContractYearList,
    VolumeList,
    SectionList,
    SorList,
  },
  setup(props, { root }) {
    const contract = ref(null);
    const getContract = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/contract/",
        params: { contract_id: root.$route.params.contractId },
      });

      if (response.body.success) {
        contract.value = response.body.contract;

        if (!contract.finalised_at) {
          await getSors();
        }
      }
    };
    const canManageContract = computed(() => {
      if (contract.value) {
        return (
          root.$store.getters.hasPermission(null) ||
          _.some(
            contract.value.admins,
            (a) => a.account.id === root.$store.getters.account.id
          )
        );
      }

      return false;
    });

    const requiredRules = ref([
      (value) => !!value || root.$t("rules.required"),
    ]);
    const selectedSorId = ref(null);
    const sors = ref([]);
    const sorOptions = computed(() => {
      return sors.value.map((s) => {
        return {
          text: s.name,
          value: s.id,
        };
      });
    });
    const getSors = async function () {
      const filters = {
        type: [SOR_TYPE.SOR, SOR_TYPE.CORRIGENDUM],
        action_input_finalised_at: true,
        hidden: [false],
      };
      if (contract.value.sor) {
        filters["hidden"] = undefined;
      }
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/sor/",
        params: {
          filters,
        },
      });

      if (response.body.success) {
        sors.value = response.body.sors;
      }
    };

    const finaliseContractSor = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/contract/finalise_sor/",
        params: {
          contract_id: root.$route.params.contractId,
          sor_id: selectedSorId.value,
          details: contract.value.details,
        },
      });

      if (response.body.success) {
        await getContract();
      }
    };

    // ASoR
    const downloadASoRTemplate = function () {};
    const aSorRefreshTrigger = ref(false);
    const createASoR = async function () {
      await root.$dialog.showAndWait(CreateContractASoRDialog, {
        contractId: root.$route.params.contractId,
        showClose: false,
        persistent: true,
      });
      aSorRefreshTrigger.value = true;
    };
    const finaliseASoR = async function () {
      if (
        await root.$dialog.confirm({
          text: root.$t("contract.a_sor_finalise_confirm_msg"),
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/finalise/",
          params: { contract_id: root.$route.params.contractId },
        });

        if (response.body.success) {
          await getContract();
        }
      }
    };
    const unfinaliseASoR = async function () {
      if (
        await root.$dialog.confirm({
          text: root.$t("contract.a_sor_un_finalise_confirm_msg"),
        })
      ) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/unfinalise/",
          params: { contract_id: root.$route.params.contractId },
        });

        if (response.body.success) {
          await getContract();
        }
      }
    };
    const aSorItems = computed(() => {
      if (contract.value && contract.value.a_sor) {
        return [contract.value.a_sor];
      }

      return [];
    });
    const aSorHeaders = ref([
      { text: "Last Update", value: "created_at", width: 150 },
      { text: "Filename", value: "excel.filename" },
      { text: "Finalised At", value: "finalised_at", width: 150 },
      { text: "", value: "actions", sortable: false, width: 100 },
    ]);
    const previewASor = async function (item) {
      await root.$dialog.showAndWait(ContractASorPreviewModal, {
        sorId: item.id,
        aSor: contract.value.a_sor,
        width: "70vw",
        showClose: false,
        persistent: true,
        scrollable: true,
      });

      await getContract();
    };

    const actionHeaders = ref([
      {
        text: root.$t("action_input.created_at"),
        value: "created_at",
        width: 150,
      },
      { text: root.$t("action_input.filename"), value: "filename" },
      {
        text: root.$t("action_input.finalised_at"),
        value: "finalised_at",
        width: 150,
      },
    ]);

    //
    const contractActionItems = computed(() => {
      if (contract.value && contract.value.action_input) {
        return [contract.value.action_input];
      }

      return [];
    });

    // Contract Percentage
    const contractYearRefreshTrigger = ref(false);
    const downloadContractPercentageTemplate = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/contract/contract_percentage/template/",
        params: {
          contract_id: root.$route.params.contractId,
        },
        opt: { extra: { responseType: "arraybuffer" } },
      });

      let blob = new Blob([response.data], {
        type: response.headers.get("content-type"),
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = decodeURI(response.headers.get("content-filename"));
      link.click();
    };
    const importContractPercentageTemplate = async function () {
      await root.$dialog.showAndWait(ImportContractPercentageDialog, {
        contractId: root.$route.params.contractId,
        showClose: false,
        persistent: true,
        width: 640,
      });

      contractYearRefreshTrigger.value = true;
    };

    // Contract Admin
    const contractAdminRefreshTrigger = ref(false);
    const addContractAdmin = async function () {
      const account = await root.$dialog.showAndWait(SelectAccountDialog, {
        title: root.$t("contract_admin.add_title"),
        showClose: false,
        persistent: true,
        width: "640px",
      });

      if (account) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/admin/create/",
          params: {
            contract_id: root.$route.params.contractId,
            account_id: account.id,
          },
        });

        if (response.body.success) {
          contractAdminRefreshTrigger.value = true;
        }
      }
    };

    // Contract User
    const contractUserRefreshTrigger = ref(false);
    const addContractUser = async function () {
      const account = await root.$dialog.showAndWait(SelectAccountDialog, {
        title: root.$t("contract_user.add_title"),
        showClose: false,
        persistent: true,
        width: "640px",
      });

      if (account) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/user/create/",
          params: {
            contract_id: root.$route.params.contractId,
            account_id: account.id,
          },
        });

        if (response.body.success) {
          contractUserRefreshTrigger.value = true;
        }
      }
    };

    onMounted(async () => {
      await root.$store.dispatch(ACTION_TYPES.GET_ME);
      await getContract();
    });

    return {
      contract,
      canManageContract,

      requiredRules,
      selectedSorId,
      sorOptions,

      finaliseContractSor,

      downloadASoRTemplate,
      aSorRefreshTrigger,
      createASoR,
      finaliseASoR,
      unfinaliseASoR,
      aSorItems,
      aSorHeaders,
      previewASor,

      actionHeaders,

      contractActionItems,

      contractYearRefreshTrigger,
      downloadContractPercentageTemplate,
      importContractPercentageTemplate,

      contractAdminRefreshTrigger,
      addContractAdmin,

      contractUserRefreshTrigger,
      addContractUser,
    };
  },
};
</script>

<style lang="less">
.contract-detail {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .contract-info-wrapper {
    flex: 0 0 auto;
    display: flex;

    .contract-info {
      flex: 1 1 0;
    }

    .contract-info-btns {
      flex: 0 0 auto;
      width: 200px;
    }
  }

  .breadcrumbs {
    .v-btn--active {
      color: #ffffff !important;
      opacity: 1 !important;
    }
  }

  .contract-disable-row {
    flex: 0 0 auto;
    background-color: rgba(238, 119, 122, 0.1);
  }

  .contract-detail-row {
    flex: 0 0 auto;
    background-color: #ffffff;

    &.finalised {
      background-color: #ffffff88;
    }
  }

  .contract-finalised-div {
    border-radius: 12px;
    padding: 2px 8px;
    border: solid 1px #6c757d;
    color: #6c757d;
    background-color: rgba(108, 117, 125, 0.1);

    &.finalised {
      border: solid 1px #5bc23f;
      color: #5bc23f;
      background-color: rgba(91, 194, 63, 0.2);
    }
  }

  .contract-select-sor-row {
    margin-top: 16px;
    background-color: #ffffff;
  }

  .contract-sor-row {
    margin-top: 16px;
    background-color: #f7f7f7;
  }

  .contract-a-sor-disable-row {
    flex: 0 0 auto;
    background-color: rgba(238, 119, 122, 0.1);
  }
}
</style>
